var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "report" }, [
    _c(
      "div",
      { staticClass: "page-header-wrapper" },
      [
        _c("PageHeader", { attrs: { title: "Quality Review" } }),
        _c(
          "el-form",
          { staticClass: "filter-wrapper", attrs: { "label-width": "60px" } },
          [
            _c(
              "el-col",
              {
                directives: [
                  {
                    name: "role",
                    rawName: "v-role",
                    value: [1],
                    expression: "[1]",
                  },
                ],
                attrs: { span: 6 },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "Role", prop: "role" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "Please select Role",
                          filterable: "",
                        },
                        on: { change: _vm.roleChange },
                        model: {
                          value: _vm.form.role,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "role", $$v)
                          },
                          expression: "form.role",
                        },
                      },
                      _vm._l(_vm.roleOptions, function (item, idx) {
                        return _c("el-option", {
                          key: idx,
                          attrs: { label: item.name, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              {
                directives: [
                  {
                    name: "role",
                    rawName: "v-role",
                    value: [1],
                    expression: "[1]",
                  },
                ],
                attrs: { span: 6 },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "Leader", prop: "taId" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "Please select Leader",
                          filterable: "",
                        },
                        on: { change: _vm.taChange },
                        model: {
                          value: _vm.form.taId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "taId", $$v)
                          },
                          expression: "form.taId",
                        },
                      },
                      _vm._l(_vm.taOptions, function (item, idx) {
                        return _c("el-option", {
                          key: idx,
                          attrs: { label: item.TAName, value: item.TAID },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 6 } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "Team" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "Please select Team",
                          filterable: "",
                        },
                        on: { change: _vm.teamChange },
                        model: {
                          value: _vm.form.teamId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "teamId", $$v)
                          },
                          expression: "form.teamId",
                        },
                      },
                      _vm._l(_vm.teamOptions, function (item, idx) {
                        return _c("el-option", {
                          key: idx,
                          attrs: { label: item.TeamName, value: item.TeamID },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 6 } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "User" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "Please select User",
                          filterable: "",
                        },
                        on: { change: _vm.mlChange },
                        model: {
                          value: _vm.form.mlId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "mlId", $$v)
                          },
                          expression: "form.mlId",
                        },
                      },
                      _vm._l(_vm.mlListOptions, function (item, idx) {
                        return _c("el-option", {
                          key: idx,
                          attrs: { label: item.MLName, value: item.MLID },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 6 } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      "label-width": _vm.labelWidth,
                      label: _vm.nameLabel,
                    },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "se-select",
                        attrs: {
                          multiple: "",
                          "collapse-tags": "",
                          placeholder: `Please select ${_vm.nameLabel}`,
                          filterable: "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.seOrMonthSelectChange($event, "seId")
                          },
                        },
                        model: {
                          value: _vm.form.seId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "seId", $$v)
                          },
                          expression: "form.seId",
                        },
                      },
                      _vm._l(_vm.seListOptions, function (group, i) {
                        return _c(
                          "el-option-group",
                          { key: i, attrs: { label: group.MLName } },
                          _vm._l(group.SE, function (item, j) {
                            return _c("el-option", {
                              key: j,
                              attrs: { label: item.SEName, value: item.SEID },
                            })
                          }),
                          1
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.shouldShowColumn
              ? _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "HCP Type",
                          prop: "hcpType",
                          "label-width": "100px",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "Please select type" },
                            model: {
                              value: _vm.form.hcpType,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "hcpType", $$v)
                              },
                              expression: "form.hcpType",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "All", value: "" },
                            }),
                            _c("el-option", {
                              attrs: { label: "SE", value: "SE" },
                            }),
                            _c("el-option", {
                              attrs: { label: "CE", value: "CE" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-col",
              { attrs: { span: 6 } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "Type" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "Please select Type" },
                        on: { change: _vm.typeChange },
                        model: {
                          value: _vm.form.type,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "type", $$v)
                          },
                          expression: "form.type",
                        },
                      },
                      _vm._l(_vm.typeOptions, function (item) {
                        return _c("el-option", {
                          key: item.key,
                          attrs: { label: item.value, value: item.key },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 6 } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "Status" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "Please select Status",
                          disabled: _vm.form.type != 2,
                        },
                        model: {
                          value: _vm.form.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "status", $$v)
                          },
                          expression: "form.status",
                        },
                      },
                      _vm._l(_vm.statusOptions, function (item) {
                        return _c("el-option", {
                          key: item.ParamID,
                          attrs: {
                            label: item.ParamValue,
                            value: item.ParamID,
                          },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 6 } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "Year" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "Please select year" },
                        model: {
                          value: _vm.form.year,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "year", $$v)
                          },
                          expression: "form.year",
                        },
                      },
                      _vm._l(_vm.yearsOptions, function (item) {
                        return _c("el-option", {
                          key: item.Year,
                          attrs: { label: item.Year, value: item.Year },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 6 } },
              [
                _c(
                  "el-form-item",
                  { attrs: { "label-width": _vm.labelWidth, label: "Month" } },
                  [
                    _c(
                      "el-select",
                      {
                        directives: [
                          { name: "multiple-tip", rawName: "v-multiple-tip" },
                        ],
                        ref: "monthSelect",
                        staticClass: "monthSelect",
                        attrs: {
                          placeholder: "Please select month",
                          multiple: "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.seOrMonthSelectChange($event, "month")
                          },
                        },
                        model: {
                          value: _vm.form.month,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "month", $$v)
                          },
                          expression: "form.month",
                        },
                      },
                      _vm._l(_vm.monthOptions, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "query-action" },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      icon: "el-icon-search",
                      disabled: _vm.queryable,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.getTableData()
                      },
                    },
                  },
                  [_vm._v(" Query ")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "right-export-btn",
                    attrs: {
                      type: "primary",
                      icon: "iconfont icon-export",
                      disabled: _vm.exportable,
                      loading: _vm.exporting,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.getTableData(true)
                      },
                    },
                  },
                  [_vm._v(" Export ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "table-wrapper" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.tableLoading,
                expression: "tableLoading",
              },
            ],
            attrs: {
              data: _vm.tableData,
              "element-loading-text": "Loading...",
            },
          },
          [
            _c("el-table-column", {
              attrs: { prop: "MLName", label: "User", width: "120" },
            }),
            _c("el-table-column", {
              attrs: { prop: "TaConfigName", label: "TA", "min-width": "130" },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "SEName",
                label: _vm.nameLabel,
                "min-width": "90",
              },
            }),
            _vm.shouldShowColumn
              ? _c("el-table-column", {
                  attrs: {
                    prop: "TypeDescription",
                    label: "HCP Type",
                    "min-width": "80",
                  },
                })
              : _vm._e(),
            _c("el-table-column", {
              attrs: {
                prop: "RequestType",
                label: "Request Type",
                "min-width": "160",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "min-width": "145",
                prop: "RequestContent",
                label: "Request Content",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      row.RequestContent.length < 25
                        ? [_vm._v(" " + _vm._s(row.RequestContent) + " ")]
                        : _c(
                            "el-popover",
                            {
                              attrs: {
                                placement: "top-start",
                                width: "300",
                                trigger: "hover",
                                content: row.RequestContent,
                                "popper-class": "request-content-popover",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "request-content-wrapper",
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        `${row.RequestContent.substring(
                                          0,
                                          25
                                        )}...`
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "min-width": "150",
                prop: "FullfillmentDate",
                label: "Fulfillment Date",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "Fulfillment Description",
                "min-width": "185",
                prop: "FullfillmentDesc",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c("div", {
                        domProps: { innerHTML: _vm._s(row.FullfillmentDesc) },
                      }),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "Meeting Title",
                "min-width": "120",
                prop: "MeetingTitle",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "min-width": "130",
                prop: "MeetingStatus",
                label: "Meeting Status",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }